<template lang="html">
  <div class="content">
    <search :params.sync="params" :showCharts="showCharts" :defaultDateRange="24" :disabled="['type']" />
    <div class="chart" ref="chart"></div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import qs from "qs";

import search from '../../components/search';

export default {
  components: {
    search
  },
  data() {
    return {
      params:{}
    };
  },
  mounted() {
    
  },
  methods: {
    showCharts() {
      this.chart = this.chart || echarts.init(this.$refs.chart, "light");

      window.addEventListener("resize", () => {
        this.chart.resize();
      });
      this.chart.showLoading();

      this.fetch().then(values => {
        this.chart.hideLoading();
      });
    },
    fetch() {
      const { clientType, dateRange } = this.params;
      const query = {
        client: clientType,
        dateRange
      }

      return axios.all([
        axios.get(`/timeRatio/doJoin?${qs.stringify(query)}`),
        axios.get(`/timeRatio/doJoinAll?${qs.stringify(query)}`)
      ]).then(res => {
        const [ doJoinData, doJoinAllData ] = res;

        const days = doJoinData.data.data.map(item => item["key_as_string"].replace(' ', '\n'));

        const doJoinSeriesData = doJoinData.data.data.map(item =>
          item["avg_time"].value ? item["avg_time"].value.toFixed(2) : 0
        );
        const doJoinAllSeriesData = doJoinAllData.data.data.map(item =>
          item["avg_time"].value ? item["avg_time"].value.toFixed(2) : 0
        );

        this.setChartData(days, doJoinSeriesData, doJoinAllSeriesData);
      })
    },
    setChartData(days, doJoinSeriesData, doJoinAllSeriesData) {
      const option = {
        title: {
          text: "出券时间"
        },
        grid: {
          left: 10,
          right: 10,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                "<br/>" + params[i].marker + params[i].seriesName + " : " + params[i].value + "ms";
            }
            return relVal;
          }
        },
        legend: {
          data: ["出券时间", "整体出券时间"]
        },
        xAxis: {
          type: "category",
          data: days,
          boundaryGap: false
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: doJoinSeriesData,
            name: "出券时间",
            type: "line"
          },
          {
            data: doJoinAllSeriesData,
            name: "整体出券时间",
            type: "line"
          }
        ]
      };
      // 把配置和数据放这里
      this.chart.setOption(option);
    }
  }
};
</script>

<style lang="css" scoped>
.content {
  padding: 30px;
}
.chart {
  height: 500px;
  width: 100%;
  margin-top: 30px;
}
</style>
